var map = {
	"./Bell.svg": "c693",
	"./coupon.svg": "3f60",
	"./logout.svg": "a861",
	"./video-plus.svg": "4725",
	"./voucher.svg": "d932",
	"./webinar-quiz.svg": "0586"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46f5";